import * as e from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/FolderSimpleStar.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: m }));
o.displayName = "FolderSimpleStarIcon";
const p = o;
export {
  p as FolderSimpleStar,
  o as FolderSimpleStarIcon
};
